//Comentario necesario para codificación en UTF-8, ver Inc6743
angular.module('pphhApp').service("SecurityService", ["$http", SecurityService]);

function SecurityService ($http) {
	this.getCurrentUser = function () {
		return $http({
			method: "GET",
			url: _contextPath + "/security/user"
		});
	}
}